/* eslint-disable no-shadow */
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { http } from "@/api/index";
import { GET_TREND_SIGNALS } from "@/stores/actions/TrendSignal.js";
import i18n from "@/i18n";
import {
	OPEN_REPORT_DIALOG,
	GET_REPORT_DATA,
	RESET_REPORT_DATA,
	GET_REPORT_DATA_ERROR,
	GET_REPORT_DATA_SUCCESS,
	CLOSE_REPORT_DIALOG,
} from "@/stores/actions/WindTurbineReport";

const state = {
	reportStatus: FetchStatus.Init,
	reportDialog: false,
	data:         {},
	errorCode:    -1,
};

const Qs = require("qs");

const actions = {
	/**
	* @summary Altera o estado para o dialog de relatório true.
	* @type {void}
	*/
	[OPEN_REPORT_DIALOG]: ({ commit }) =>
	{
		commit(OPEN_REPORT_DIALOG);
	},

	/**
	* @summary Altera o estado para o dialog de relatório true.
	* @type {void}
	*/
	[RESET_REPORT_DATA]: ({ commit }) =>
	{
		commit(RESET_REPORT_DATA);
	},

	/**
	* @summary Altera o estado para o dialog de relatório false.
	* @type {void}
	*/
	[CLOSE_REPORT_DIALOG]: ({ commit }) =>
	{
		commit(CLOSE_REPORT_DIALOG);
	},

	/**
	* @summary Distribui as chamadas para obtenção de dados para construção do relatório.
	* @type {void}
	*/
	[GET_REPORT_DATA]: ({ commit, dispatch }, parameters) =>
	{
		commit(GET_REPORT_DATA);
		const queryParams = {
			startDateTime:       parameters.startDateTime,
			endDateTime:         parameters.endDateTime,
			monitoringElementId: parameters.turbineId,
		};

		http.get(`/WindTurbineEventsLog/Report/${parameters.turbineId}`, {
			params:           queryParams,
			paramsSerializer: params => Qs.stringify(params, { encode: false }),
		})
			.then((resp) =>
			{
				commit(GET_REPORT_DATA_SUCCESS, resp);
			})
			.catch((error) =>
			{
				commit(GET_REPORT_DATA_ERROR, error.response);
			});

		const sCurveParams = {
			startDateTime: parameters.startDateTime,
			endDateTime:   parameters.endDateTime,
			signalIds:     parameters.trendSettingIds,
		};
		dispatch(GET_TREND_SIGNALS, sCurveParams);
	},

};
const mutations = {
	[OPEN_REPORT_DIALOG]: (state) =>
	{
		state.reportDialog = true;
	},
	[RESET_REPORT_DATA]: (state) =>
	{
		state.data = {};
		state.errorCode = -1;
		state.reportStatus = FetchStatus.Init;
	},
	[CLOSE_REPORT_DIALOG]: (state) =>
	{
		state.reportDialog = false;
	},
	[GET_REPORT_DATA]: (state) =>
	{
		state.reportStatus = FetchStatus.Loading;
	},
	[GET_REPORT_DATA_SUCCESS]: (state, resp) =>
	{
		if (resp.status === 204)
		{
			state.data = [];
			state.error = i18n.t("ErrorMessages.NoDataForPeriod");
			state.errorCode = 204;
			state.reportStatus = FetchStatus.Loaded;
			return;
		}
		const table = [];
		for (let i = 0; i < resp.data.length; i++)
		{
			const currentEventLog = resp.data[i];
			const tableItem = {};

			tableItem.component = currentEventLog.component;
			tableItem.subComponent = currentEventLog.subComponent;
			tableItem.message = currentEventLog.message;
			tableItem.category = currentEventLog.category;
			tableItem.occurrenceCount = currentEventLog.occurrenceCount;
			tableItem.recommendation = currentEventLog.recommendation;
			table.push(tableItem);
		}
		state.reportStatus = FetchStatus.Loaded;
		state.errorCode = 200;
		state.data = table;
	},
	[GET_REPORT_DATA_ERROR]: (state, error) =>
	{
		state.reportStatus = FetchStatus.Error;
		state.error = error;
		state.errorCode = error.response;
	},
};

export default {
	state,
	actions,
	mutations,
};
